import React from "react";

import HeroGirlImage from "src/assets/images/cgm/connection-journey/hero-section-graph-girl.png";
import TransmitterSensorImage from "src/assets/images/cgm/connection-journey/transmitter-sensor.webp";

import Button from "src/components/app/Button";

type CGMStatusCardProps = {
  onStartJourney: () => void;
};

const CGMStatusCard: React.FC<CGMStatusCardProps> = ({ onStartJourney }) => {
  return (
    <>
      <div className="relative">
        <img src={HeroGirlImage} alt="CGM intro" className="w-full h-auto" />
      </div>

      <div className="mx-4 mb-4 rounded-xl bg-[#EEF4FF] p-4">
        <div className="flex items-center gap-4">
          <img
            src={TransmitterSensorImage}
            alt="CGM Transmitter and Sensor"
            className="h-16 w-16 object-contain"
          />
          <p className="text-base font-normal leading-[150%] text-gray-800">
            You should have the CGM sensor and transmitter to get started
          </p>
        </div>
      </div>

      <div className="px-4 pb-4">
        <Button
          variant="contained"
          rounded="full"
          fullWidth
          onClick={onStartJourney}
        >
          Start Connection Journey
        </Button>
      </div>

      <div
        className="border-b-2 border-dashed border-gray-400"
        style={{
          backgroundImage:
            "url('data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%239ca3af' stroke-width='4' stroke-dasharray='6%2c 14' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e')",
        }}
      />
    </>
  );
};

export default CGMStatusCard;
